import { Component, OnInit, Input, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmployeeViewModalComponent } from '../../modals/employee-view-modal/employee-view-modal.component';
import { DataResetService } from '../../../services/data-reset.service';
import { UserService } from '../../../services/user.service';
import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { PostsService } from '../../../services/posts.service';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() isMainMenuVisible: boolean = true;

  isDashboardMenuOpen: boolean = false;
  isProfileMenuOpen: boolean = false;

  constructor(
    private readonly dataResetService: DataResetService, // do not remove
    private readonly destroyRef: DestroyRef,
    private readonly router: Router,
    public authService: AuthService,
    public userService: UserService,
    public companyService: CompanyService,
    public postsService: PostsService,
    public dialogService: MatDialog
  ) {}

  ngOnInit(): void {
    this.authService.isLoggedIn().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (isLoggedIn) => {
        if (isLoggedIn) {
          if (this.authService.getCurrentCompanyId()) {
            if (!this.companyService.companyInfo$.value) {
              this.companyService.getCompanyInfo();
            }

            if (this.isMainMenuVisible) {
              this.postsService.getUnreadPostsCount();
            }
          }
        }
      }
    });
  }

  onChooseCompany(id: number) {
    this.router.navigate(['/workspace', id]).catch();
  }

  openEmployeeModal() {
    this.dialogService.open(EmployeeViewModalComponent, {
      panelClass: 'dialog-overlay-pane',
      data: this.userService.profileInfo$.getValue().id,
      width: '920px'
    });
  }

  openDashboardMenu() {
    this.isDashboardMenuOpen = !this.isDashboardMenuOpen;
  }

  clickedOutsideDashboardMenu() {
    this.isDashboardMenuOpen = false;
  }

  openProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
  }

  clickedOutsideProfileMenu() {
    this.isProfileMenuOpen = false;
  }
}
